import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation UpdateInstallmentPlan(
    $id: Int!
    $name: String!
    $enabled: Boolean!
    $depositType: String!
    $depositAmount: Int
    $installmentCount: Int!
    $frequencyType: String!
    $frequencyAmount: Int!
    $withdrawDay: String!
    $withdrawBasedOnCheckout: Boolean!
  ) {
    updateInstallmentPlan(
      id: $id
      input: {
        name: $name
        enabled: $enabled
        deposit_type: $depositType
        deposit_amount: $depositAmount
        installment_count: $installmentCount
        frequency_type: $frequencyType
        frequency_amount: $frequencyAmount
        withdraw_day: $withdrawDay
        withdraw_based_on_checkout: $withdrawBasedOnCheckout
      }
    ) {
      id
      scopeType
      scopeId
      name
      enabled
      depositType
      depositAmount
      installmentCount
      frequencyType
      frequencyAmount
      withdrawDay
      withdrawBasedOnCheckout
    }
  }
`;
